<template lang="pug">
//- 高中英語
.group-index.page-index
  //- 內容 TOP (內有 搜尋bar 及 通知區塊 )
  ContentTop
  .group-title M 美爾頓高中英語

  .row.group-content
    .group-content-right.padding-none
      FilterCom(
        :language_filter="language_filter",
        :class_filter="class_filter",
        @setLang="setCourseLange",
        @setCourse="setCourseType",
        use_type="senior"
      )
    .clearfix

  .newpark-list
    //- 課程區塊
    .item-content-box(
      v-for="course in courseList",
      @click="clickOption(course)"
    )
      .item-content(v-bind:class="'bg-purple'")
        .item-up
          .item-title {{ course.zhTitle }}
          .item-title {{ course.enTitle }}

        .item-down
          //- 課程資訊
          .coruse-length {{ course.teacher.name }}
            span {{ course.directions }}
    .clearfix

  .more-btn.click-cursor(v-if="page < perMaxPage", @click="getNextSeries()") 載入更多
</template>
<script>
// import $ from 'jquery'
import ContentTop from '@/components/content-top/content-top'
import DateCom from '@/components/date'
import FilterCom from '@/components/filter'
import GroupTimeTableArea from '@/components/group/group-timetable-area'
export default {
  coures_teacher: {
    name: 'Index',
  },
  components: {
    ContentTop,
    DateCom,
    FilterCom,
    GroupTimeTableArea
  },
  data () {
    return {
      //- 頁面
      page: 1,
      //- 語言篩選狀態
      language_filter: "all",
      //- 課程篩選狀態
      class_filter: "",
      //- 課程data
      coursetable_data: {},
      //- 自動化設定畫面方向
      autoSetScreen: false,
      //- Banner 清單 
      banners: [],
      //- 主題清單
      courseList: [],
      //- 控制下頁按鈕是否出現
      //- 如果達到最大頁數則應該要被開啟 (不出現按鈕)
      isMaxPage: false,
      perMaxPage: 1,
      //- 日期開關
      date_turn: false,
    };
  },
  async created () {
    // 關閉載入中畫面
    this.$root.closeLoading()
    // 初始化頁數
    this.page = 1
    // 獲取高中英語列表
    await this.getSeries()
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    // 獲取課程列表
    async getSeries () {
      // 初始化課程列表
      this.courseList = (this.page === 1) ? [] : this.courseList
      // 獲取課程列表資料
      await this.$root.apis.getRetionCourseList(this.page, '2', 'all', this.language_filter, this.processGetSeriesSuccess, this.processStatusError)
    },
    async processGetSeriesSuccess (_response) {
      var vm = this
      this.perMaxPage = _response.body.preMax
      _response.body.data.forEach(function (_series) {
        vm.courseList.push(_series)
      })
    },
    async processStatusError (_error) {
      console.log(_error)
    },
    // 獲取下一頁資料
    async getNextSeries () {
      if (this.page >= this.perMaxPage) {
        return
      }

      // 進入下一頁
      this.page += 1
      // 請求獲取資料
      await this.getSeries()
    },
    // 設定課程語言
    setCourseLange (_langID) {
      this.language_filter = _langID
      // 初始化頁數
      this.page = 1
      // 獲取課程列表
      this.getSeries()
    },
    // 設定課程類別
    setCourseType (_courseType) {
      this.class_filter = _courseType
      // 初始化頁數
      this.page = 1
      // 獲取課程列表
      this.getSeries()
    },
    // 鎖定畫面為直向
    async setLockScreen () {
      // 針對 iOS 不處理自動直向
      if (this.$root.platform === 'iOS') {
        return
      }

      // 如果正在直播中, 不鎖定直向
      if (this.$root.live_view_status) {
        return
      }

      // 重設畫面方向
      await this.$root.core.lockScreen()
    },
    // 確認語系對應的顏色
    confirmColor (_isExpired = false, _courseLang = '') {

      // 當課程已經結束
      if (_isExpired) {
        return 'bg-gray-1'
      }

      // 根據語言判斷顏色
      switch (_courseLang) {
        case 'en':
          return 'bg-purple'

        case 'ja':
          return 'bg-orange'

        default:
          return 'bg-green'
      }
    },
    // 當用戶點擊課程按鈕
    clickOption (_course) {
      console.log(_course)
      this.course_id = _course.id
      this.course = _course

      // 是否已經購買過課程
      if (_course.is_order) {
        this.openCourseVideo()
        return
      }

      // 處理登記直播
      this.$root.openOptionView({
        title: "高中英語",
        text_1: "您選擇高中英語",
        text_2: '需要扣除 ' + this.$root.common.formatNumber(_course.course_point, 0) + ' 點數，扣點後24小時內可進行本堂課程重複點選學習。',
        course_text: _course.title,
        option_1: "確認",
        option_2: "我再考慮",
        option_1_fun: this.openCourseVideo,
        option_2_fun: false
      })
      return
    },
    // 請求進入專區課程
    async openCourseVideo () {
      // 開啟載入中
      this.$root.useLoading()
      // 向後端請求進入專區課程
      await this.$root.apis.newRegionCourse(this.course_id, this.processRegionCourseSuccess, this.processRegionCourseError)
      // 關閉載入中
      this.$root.closeLoading()
    },
    // 處理返回直播請求成功的資料
    processRegionCourseSuccess (_response) {
      // 處理異常資料
      if (_response.body.error_code !== 0 && _response.body.error_code !== 3001) {
        return this.processRegionCourseError(_response)
      }

      // 進入會議室
      console.log('--> 請求進入影音播放功能...')
      this.$root.openRegionCourse(this.course)
      // 重新抓取課程資料
      this.getSeries()
    },
    // 處理返回直播請求失敗的資料
    processRegionCourseError (_error) {
      this.$root.openOptionView({
        title: "發生問題",
        text_1: _error.body.message,
        text_2: '',
        course_text: '',
        option_1: "瞭解",
        option_2: '',
        option_1_fun: false,
        option_2_fun: false
      })
    }
  }
}
</script>
<style lang="sass">
.filter-com
  width: 100%
  margin: 3rem 0 0 0
  overflow: hidden
  .language
    margin-right: 2rem
  .language-filter
  .filter-sm-title
    margin: .55rem 0 .1rem 0
  .class-box
    padding-left: .2rem
    width: 100%
    overflow: auto
    .class-filter
      width: 40rem

  .filter-item
    float: left
    height: 2.6rem
    line-height: 2.6rem
    margin-right: .5rem
    border-radius: 5px
    padding: 0 1.3rem
    font-size: .7rem
    font-weight: 500
    text-align: center
    &:active
      opacity: .6
  .bg-blue-1
    background: #2e50ff
    color: #fff
    font-size: .8rem
  .bg-gray-1
    background: #f3f3f3
    color: #91a1c1
.newpark-list
  width: calc(100% - 8rem)
  margin: 2rem 4rem
  display: grid
  gap: 10px
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr))
  .bg-purple
    background: #cceafb
  .bg-green
    background: #e7bbfc
  .bg-orange
    background: #fadbe8

  .item-content-box
    width: 100%

    .item-content
      border-radius: 10px
      width: 320px
      padding: 1rem
      position: relative
      &:active
        opacity: .7

    .item-down
      margin-top: 2vmin
      position: relative
      text-align: left
      padding: 0 0vmin 0 0vmin
      width: 100%
      .teacher-box
        margin: 2vmin 0
        .teacher-img
          width: 14vmin
          height: 14vmin
          object-fit: cover
          border-radius: 50%
          float: left
          margin-right: 3vmin
        .teacher-name
          color: #191d35
          font-size: 4vmin
          font-weight: 500
          line-height: 7vmin
          margin: 3.5vmin 0
          float: left
          max-width: 22vmin
      .coruse-length
        color: #91a1c1
        font-size: .9rem
        font-weight: 500
        line-height: 1rem
        margin-top: 1rem
        span
          color: #91a1c1
          margin-left: .3rem
    .item-title
      color: #191d35
      font-size: .9rem
      font-weight: 500
      line-height: 20px
      overflow: hidden
      text-overflow: ellipsis
      display: -webkit-box
      -webkit-line-clamp: 2
      -webkit-box-orient: vertical
      white-space: normal
      margin-top: 0.2rem
.more-btn
  margin: 0 auto 5rem auto
  width: fit-content
  height: 2.6rem
  line-height: 2.6rem
  border-radius: 5px
  padding: 0 1.3rem
  font-size: .7rem
  font-weight: 500
  text-align: center
  background: #2e50ff
  color: #fff
  font-size: .8rem
</style>
